import Navbar from '../components/NavbarDashboard';
import NavbarMobile from '../components/NavbarDashboardMobile';
import styles from '../styles/Dashboard.module.css';
import { UserContext } from '../lib/context';
import { firestore, serverTimestamp } from '../lib/firebase';
import { useState, useEffect, useContext } from 'react';
import { useRouter } from 'next/router';
import Skeleton from 'react-loading-skeleton';
import { QRCodeSVG } from 'qrcode.react';
import 'react-loading-skeleton/dist/skeleton.css';
import toast from 'react-hot-toast';
import { mp } from '../lib/mixpanel';

export default function Dashboard() {
  return (
    <>
      <Navbar />
      <Body />
    </>
  );
}

function Body() {
  const { user, userData } = useContext(UserContext);
  const [referral, setReferral] = useState(false);
  const [stateLoaded, setStateLoaded] = useState(false);
  const router = useRouter();

  const getItem = async (collection, uid) => {
    const presRef = await firestore.collection(collection).doc(uid).get();
    return presRef.data();
  };

  useEffect(async () => {
    if (user && userData) {
      // Get the referral object and set it into the referral object
      setReferral(await getItem('referralCode', userData.referral));
    }
  }, [user, userData]);

  useEffect(async () => {
    if (referral) {
      mp.track('referral_land_cta', {
        referralCode: referral.code,
      });
      setStateLoaded(true);
    }
  }, [referral]);

  useEffect(() => {
    console.log(`State Fully Loaded: ${stateLoaded}`);
  }, [stateLoaded]);

  const copyCode = async () => {
    if (navigator.clipboard) {
      navigator.clipboard
        .writeText(
          `https://app.gemmahealth.ca/r/${userData.referral}?from=copy`
        )
        .then(
          () => {
            toast.success('Copied to clipboard. Share with your friends!');
          },
          (err) => {
            console.log('Failed to copy the text to clipboard.', err);
          }
        );
    }
    mp.track('referral_invite_cta', {
      userID: user.uid,
      name: 'copy code to clipboard',
    });
  };

  const share = async () => {
    if (navigator.share) {
      navigator
        .share({
          title: 'Get a free online prescription for birth control or acne.',
          text: 'Join Gemma and get a free prescription for birth control or acne in 5 minutes.',
          url: `https://app.gemmahealth.ca/r/${userData.referral}?from=share`,
        })
        .then(() => {
          console.log('Thanks for sharing!');
        })
        .catch(console.error);
    }
    mp.track('referral_invite_cta', {
      userID: user.uid,
      name: 'mobile share button',
    });
  };

  return (
    <div className={`${styles['dashboard-container']} red`}>
      <div className={`${styles['dashboard-container-max']} red`}>
        <div className={`${styles['div-flex-refer']} red`}>
          <div className={`${styles['div-next-max']} red`}>
            {/* If state NOT ready, put a skeleton */}
            {!stateLoaded && (
              <div className={`${styles['dashboard-item-container']} red`}>
                <Skeleton />
                <Skeleton />
                <Skeleton />
              </div>
            )}
            {/* If state IS ready, put the actual UI */}
            {stateLoaded && (
              <>
                <div className={`${styles['referral-title']} red`}>
                  Invite friends and earn $250!
                </div>
                <div className={`${styles['qr-code-container']} red`}>
                  <div className={`${styles['qr-code']} red`}>
                    <QRCodeSVG
                      value={`https://app.gemmahealth.ca/r/${userData.referral}?from=qrcode`}
                      size={156}
                      bgColor="#fff8f8"
                      // imageSettings={{
                      //   src: '/landing/gemma-qr.png',
                      //   width: 20,
                      //   height: 20,
                      //   excavate: true,
                      // }}
                    />
                  </div>
                </div>
                {/* <div className={`${styles['referral-code']} red`}>
                  {userData.referral}
                </div> */}

                <div className={`${styles['referral-rules-container']} red`}>
                  <div>
                    {`Invite a friend and they get a FREE consultation (worth $${referral.giveAmount}).`}
                  </div>
                  <div className={`${styles['referral-rules-margin']} red`} />
                  <div className={`${styles['referral-rules-margin']} red`} />
                  <br />
                  <div>
                    {`Get $${
                      referral.getAmount
                    } each time someone joins with your
                    referral code. Earn the reward up to ${
                      referral.maxRedemptions
                    } times. Make $${
                      referral.maxRedemptions * referral.getAmount
                    } and spend the dollars you earn on Gemma.`}
                  </div>
                </div>

                {navigator.share ? (
                  <div className={`${styles['qr-code-container']} red`}>
                    <button
                      onClick={share}
                      className={`${styles['copy-referral-code']} red`}
                    >
                      Share invitation
                    </button>
                  </div>
                ) : (
                  <div className={`${styles['qr-code-container']} red`}>
                    <button
                      onClick={copyCode}
                      className={`${styles['copy-referral-code']} red`}
                    >
                      Copy invite link
                    </button>
                  </div>
                )}
                <div className={`${styles['referral-rules-container']} red`}>
                  <div>{`Total Earned: $${
                    referral.usersRedeemed.length * referral.getAmount
                  } / ${referral.maxRedemptions * referral.getAmount}`}</div>
                </div>
              </>
            )}
            <NavbarMobile />
          </div>
        </div>
      </div>
    </div>
  );
}
